/* global gettext */
import { initFilterCounters } from './common-catalog.js'

const getBaseUrl = () => {
    const { location: { origin, pathname } } = window
    return new URL(pathname, origin).toString()
}

const filterBtnClassName = '.filter.catalog-filter-plugin'
const getCurrentFilterIDs = () => {
    const selectedFilters = document.querySelectorAll(`${filterBtnClassName}.selected`)
    const filterIDs = [...selectedFilters].map((filter) => filter.getAttribute('data-filter_id'))

    return filterIDs
}

const filterSkeleton = '/static/img/filter-skeleton.svg'
const contentSkeleton = '/static/img/job-offer-skeleton.svg'
const filterCategorySectionClassName = '.common-catalog-filter-type-frame'
const filterContentClassName = '.catalog-item'

const addSkeletons = () => {
    const createSkeleton = (skletonSrc) => {
        const newImg = document.createElement('img')
        newImg.src = skletonSrc

        return newImg
    }

    const filterSections = document.querySelectorAll(filterCategorySectionClassName)

    // Replace filters by skeletons
    for (const filterSection of filterSections) {
        const sectionContent = filterSection.querySelector('.collapse')

        if (sectionContent.classList.contains('show')) {
            sectionContent.replaceChildren(createSkeleton(filterSkeleton))
        }
    }

    const filterContents = document.querySelectorAll(filterContentClassName)

    // Replace content by skeletons
    for (const filterContent of filterContents) {
        filterContent.replaceChildren(createSkeleton(contentSkeleton))
    }
}

const filterIndicatorWrapperID = '#current-filters'
const toggleFilterIndicator = (isFilterVisible) => {
    const filterIndicatorWrapper = document.querySelector(filterIndicatorWrapperID)
    if (filterIndicatorWrapper) {
        if (isFilterVisible) {
            filterIndicatorWrapper.classList.remove('d-none')
            filterIndicatorWrapper.classList.add('d-block')
            filterIndicatorWrapper.classList.add('d-lg-none')
        } else {
            filterIndicatorWrapper.classList.remove('d-block')
            filterIndicatorWrapper.classList.add('d-none')
        }
    }
}

const confirmBtnID = '#confirm-filter'
const toggleConfirmFilterButton = (isVisible) => {
    const btn = document.querySelector(confirmBtnID)
    if (btn) {
        if (isVisible) {
            btn.classList.remove('d-none')
            btn.classList.add('d-block')
        } else {
            btn.classList.add('d-none')
            btn.classList.remove('d-block')
        }
    }
}

const resetFilterBtnID = '#reset-filters-mobile'
const toggleResetFilterBtn = (isVisible) => {
    const btn = document.querySelector(resetFilterBtnID)
    if (btn) {
        if (isVisible) {
            btn.classList.remove('d-none')
            btn.classList.add('d-block')
        } else {
            btn.classList.add('d-none')
            btn.classList.remove('d-block')
        }
    }
}

const offersNumWrapperID = '#current-offers'
const toggleCurrentOffers = (isVisible) => {
    const offersNum = document.querySelector(offersNumWrapperID)
    if (offersNum) {
        if (isVisible) {
            offersNum.classList.remove('d-none')
        } else {
            offersNum.classList.add('d-none')
            offersNum.classList.add('d-lg-block')
        }
    }
}

const showFilterBtnID = '#show-filters'
const toggleFilterBtn = (isVisible) => {
    const showFilterBtn = document.querySelector(showFilterBtnID)
    if (showFilterBtn) {
        const { classList } = showFilterBtn

        if (isVisible) {
            classList.remove('d-none')
        } else {
            classList.add('d-none')
        }
    }
}

const contentClassName = '.content'
const toggleContent = (isVisible) => {
    const content = document.querySelector(contentClassName)
    if (content) {
        if (isVisible) {
            content.classList.remove('d-none')
        } else {
            content.classList.add('d-none')
            content.classList.add('d-lg-block')
        }
    }
}

const wrapperClassName = '.left-side'
const toggleFilters = (isVisible) => {
    const filters = document.querySelectorAll(`${wrapperClassName} ${filterCategorySectionClassName}`)

    for (const filter of filters) {
        if (isVisible) {
            filter.classList.remove('d-none')
        } else {
            filter.classList.add('d-none')
            filter.classList.add('d-lg-block')
        }
    }

    toggleFilterIndicator(isVisible)
    toggleConfirmFilterButton(isVisible)
    toggleResetFilterBtn(isVisible)
    toggleCurrentOffers(!isVisible)
    toggleFilterBtn(!isVisible)
    toggleContent(!isVisible)

}

const filterIndicatorID = '#selected-filters'
const updateFilterIndicator = () => {
    const filterIndicator = document.querySelector(filterIndicatorID)
    if (filterIndicator) {
        const numberOfSelectedFilters = getCurrentFilterIDs().length
        filterIndicator.innerHTML = numberOfSelectedFilters
    }
}

const currentOffersIndicator = '.filtered-items-number'
const offersListClassName = '.common-catalog.list'
const blockOfFilters = '.left-side'
const filter = async(ids) => {
    let isFinished = false

    // Give loader 300ms
    setTimeout(() => {
        if (!isFinished) {
            addSkeletons()
        }
    }, 300)

    const baseURL = getBaseUrl()

    const filterIDs = getCurrentFilterIDs()
    // Merged all filter IDs into this format cocaf=<number>&cocaf=<number_1>
    const urlFilterPart = [...filterIDs, ...ids].reduce((acc, current) => {
        return acc + `&cocaf=${current}`
    }, '').replace('&', '')

    const filterURL = `${baseURL}?${urlFilterPart}`

    try {
        const result = await (await fetch(filterURL)).text()
        window.history.replaceState({}, '', `?${urlFilterPart}`)
        const parser = new DOMParser()
        const body = parser.parseFromString(result, 'text/html').querySelector('body')

        const filterResults = body.querySelector(offersListClassName)
        const currentOffersNum = body.querySelector(currentOffersIndicator).innerHTML

        // replace filter with new numbers
        document.querySelector(blockOfFilters).outerHTML = body.querySelector(blockOfFilters).outerHTML

        // replace by new results
        document.querySelector(offersListClassName).outerHTML = filterResults.outerHTML

        // update offers number
        document.querySelector(currentOffersIndicator).innerHTML = currentOffersNum

    } finally {
        isFinished = true
        // re-register all handlers
        // eslint-disable-next-line no-use-before-define
        registerAll()
        toggleFilters(true)
        updateFilterIndicator()
    }
}

const removeFromFilter = async(id) => {
    const button = document.querySelector(`span[data-filter_id="${id}"]`)
    button.classList.remove('selected')

    // re-filter based on new set of buttons (without the on with filter id)
    await filter([])
}

const registerFilterHandlers = () => {
    const filterBtns = document.querySelectorAll(filterBtnClassName)

    for (const filterBtn of filterBtns) {
        filterBtn.addEventListener('click', async() => {
            const filterID = filterBtn.getAttribute('data-filter_id')

            if (filterBtn.classList.contains('selected')) {
                await removeFromFilter(filterID)
            } else {
                await filter([filterID])
            }
        })
    }
}

const registerShowFilterBtn = () => {
    const showFilterBtn = document.querySelector(showFilterBtnID)
    if (showFilterBtn) {
        showFilterBtn.addEventListener('click', () => {
            const showFilters = !!document.querySelector(`${wrapperClassName} ${filterCategorySectionClassName}.d-none`)
            toggleFilters(showFilters)
        })
    }
}

const backBtnClassName = '.back-to-offers'
const registerBackBtn = () => {
    const currentURL = window.location.pathname

    const newURL = currentURL.split('/').slice(0, 3).join('/')
    const backBtn = document.querySelector(backBtnClassName)

    if (backBtn) {
        backBtn.addEventListener('click', () => {
            window.location = newURL
        })
    }
}

const removeBatchFromFilter = async(ids) => {
    for (const id of ids) {
        const button = document.querySelector(`span[data-filter_id="${id}"]`)
        button.classList.remove('selected')
    }
    await filter([])
}

const registerConfirmFilterBtn = () => {
    const btn = document.querySelector(confirmBtnID)
    if (btn) {
        btn.addEventListener('click', () => {
            toggleFilters(false)
        })
    }
}

const resetDesktopFilterBtnID = '#reset-filters'
const registerResetFilterBtn = () => {
    const resetFilterBtn = document.querySelector(resetFilterBtnID)
    const resetDesktopFilterBtn = document.querySelector(resetDesktopFilterBtnID)

    if (resetFilterBtn) {
        resetFilterBtn.addEventListener('click', () =>
            removeBatchFromFilter(getCurrentFilterIDs()),
        )
    }

    if (resetDesktopFilterBtn) {
        resetDesktopFilterBtn.addEventListener('click', () =>
            removeBatchFromFilter(getCurrentFilterIDs()),
        )
    }
}

const registerAll = () => {
    registerFilterHandlers()
    registerBackBtn()
    registerShowFilterBtn()
    registerResetFilterBtn()
    registerConfirmFilterBtn()
    initFilterCounters()
}

const initFilters = () => {
    updateFilterIndicator()
    toggleFilters(false)
}

const socialDivClassName = '.share-on-social'
const grayCoverClassName = '.gray-cover'
const toggleSocial = () => {
    const socialDiv = document.querySelector(socialDivClassName)
    const grayCover = document.querySelector(grayCoverClassName)

    if (socialDiv) {
        socialDiv.classList.toggle('d-block')
    }

    if (grayCover) {
        grayCover.classList.toggle('d-none')
    }
}

const toggleSocialBtnID = '#command-share'
const hideSocialBtnQuery = '.share-on-social > h4'
const registerToggleSocial = () => {
    const socialToggleBtn = document.querySelector(toggleSocialBtnID)

    if (socialToggleBtn) {
        socialToggleBtn.addEventListener('click', toggleSocial)

        const hideBtn = document.querySelector(hideSocialBtnQuery)
        if (hideBtn) {
            hideBtn.addEventListener('click', toggleSocial)
        }
    }
}

const currentLinkQuery = '.share-on-social > div > div:nth-child(1) > img'
const labelLinkQuery = '.share-on-social > div > div:nth-child(1) > p'
const registerCopyTheCurrentLink = () => {
    const currentBtnLink = document.querySelector(currentLinkQuery)

    if (registerCopyTheCurrentLink && currentBtnLink) {
        currentBtnLink.addEventListener('click', () => {
            navigator.clipboard.writeText(window.location.toString())

            currentBtnLink.setAttribute('src', '/static/img/circle-checked.svg')

            const label = document.querySelector(labelLinkQuery)
            label.innerHTML = gettext('Link copied')
        })
    }
}

const printPageBtnID = '#command-print'
const registerPrintPageBtn = () => {
    const printBtn = document.querySelector(printPageBtnID)

    if (printBtn) {
        printBtn.addEventListener('click', () => window.print())
    }
}

const addClasses = () => {
    // Add bootstrap class to submit btn
    for (const btn of document.querySelectorAll('.aldryn-from-message-frame + form button[type="submit"]')) {
        btn.classList.add('btn')
        btn.classList.add('btn-primary')
        btn.classList.add('w-100')
    }
}

export const init = () => {
    initFilters()
    registerAll()
    registerToggleSocial()
    registerCopyTheCurrentLink()
    registerPrintPageBtn()
    addClasses()
}
